<template>
  <div id="sales-page">
    <Loader :active="loading" />
    <div class="columns mx-4">
      <div class="column">
        <div class="level is-mobile">
          <div class="level-left">
            <h1 class="title has-text-primary">Ventas</h1>
          </div>
        </div>
      </div>
      <div class="column is-half">
        <div class="columns h-fit-content is-justify-content-flex-end">
          <div class="buttons level-right">
            <div class="m-1">
              <b-button
                icon-pack="fas"
                icon-left="file-excel"
                @click="generateExcelReport"
                type="is-primary"
                outlined
                v-if="my_role == 1"
                >Informe</b-button
              >
            </div>
            <div class="m-1">
              <b-button
                @click="$store.commit('setNewSale', true)"
                type="is-primary"
              >
                Crear Nueva
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button
      type="button"
      class="sales-filters-toggle crm-filters-toggle"
      :aria-expanded="filtersOpen.toString()"
      aria-controls="sales-filters-panel"
      @click="filtersOpen = !filtersOpen"
    >
      <span><i class="fas fa-filter" aria-hidden="true"></i> Filtros</span>
      <i
        :class="filtersOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
        aria-hidden="true"
      ></i>
    </button>
    <div v-show="filtersOpen" id="sales-filters-panel" class="sales-filters-panel">
    <div class="filters is-flex is-align-items-center ml-5">
      <!-- Provincia -->
      <div class="select mr-2">
        <select v-model="provincia_selected" @change="filterLeads()">
          <option :value="null">Selecciona Provincia</option>
          <option
            v-for="provincia in provincias"
            :key="provincia"
            :value="provincia"
          >
            {{ provincia }}
          </option>
        </select>
      </div>

      <!-- Origen -->
      <div class="select mr-2">
        <select v-model="origin_selected" @change="showAgents()">
          <option :value="null">Selecciona Origen</option>
          <option v-for="origin in origins" :key="origin" :value="origin">
            {{ origin }}
          </option>
        </select>
      </div>

      <!-- Departamento -->
      <div class="select mr-2">
        <select v-model="departament_selected" @change="showAgents()">
          <option :value="null">Selecciona Departamento</option>
          <option
            v-for="departament in departaments"
            :key="departament.id"
            :value="departament.id"
          >
            {{ departament.name }}
          </option>
        </select>
      </div>

      <!-- Agente -->
      <div class="select mr-2" v-if="departament_selected && agents.length > 0">
        <select v-model="agent_selected">
          <option :value="null">Selecciona Agente</option>
          <option v-for="agent in agents" :key="agent.id" :value="agent.id">
            {{ agent.lastname }}, {{ agent.name }}
          </option>
        </select>
      </div>

      <!-- Botones -->
      <div class="buttons">
        <b-button
          type="is-primary"
          @click="filterLeads"
          :disabled="
            !departament_selected && !origin_selected && !provincia_selected
          "
          class="mr-2"
        >
          <b-icon pack="fas" icon="filter" size="is-small"></b-icon>
        </b-button>
        <b-button type="is-primary" outlined @click="resetFilters">
          <b-icon pack="fas" icon="undo" size="is-small"></b-icon>
        </b-button>
      </div>
    </div>
    <div class="columns mx-4 sales-secondary-filters">
      <div class="column is-one-quarter">
        <b-field>
          <b-input
            v-model="searchValue"
            placeholder="DNI, CUIL o nombre"
          ></b-input>
        </b-field>
      </div>
      <div class="column is-one-fifth">
        <div class="field is-grouped">
          <b-button type="is-primary" @click="searching()" class="mr-1">
            <b-icon pack="fas" icon="search" size="is-small"> </b-icon>
          </b-button>

          <b-button type="is-primary" outlined @click="resetSearch()">
            <b-icon pack="fas" icon="undo" size="is-small" type="is-primary">
            </b-icon>
          </b-button>
        </div>
      </div>
      <div
        class="column is-flex is-align-items-center is-justify-content-flex-end"
      >
        <!-- 
                    date between
                -->
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <b-field class="is-align-items-center">
                <label class="m-2">Desde</label>
                <b-datepicker
                  v-model="date_from"
                  :show-week-number="true"
                  :max="date_to"
                  locale="es"
                  placeholder="Desde..."
                  trap-focus
                  position="is-bottom-left"
                >
                </b-datepicker>
              </b-field>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <b-field>
                <label class="m-2">Hasta</label>
                <b-datepicker
                  v-model="date_to"
                  :show-week-number="true"
                  :min="date_from"
                  locale="es"
                  placeholder="Hasta..."
                  trap-focus
                  position="is-bottom-left"
                >
                </b-datepicker>
              </b-field>
            </div>
            <div class="level-item">
              <b-button
                @click="fetchSales"
                type="is-primary"
                icon-pack="fas"
                icon-left="filter"
              ></b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <Board :columns="columns"></Board>
    <Modal />
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import Board from "@/components/Sales-board.vue";
import Search from "@/components/Search.vue";
import Modal from "@/components/Sale-modal.vue";
import moment from "moment";

export default {
  name: "SalesPage",
  components: {
    Board,
    Search,
    Modal,
    Loader,
  },
  data() {
    return {
      provincias: [
        "Buenos Aires",
        "Catamarca",
        "Chaco",
        "Chubut",
        "Córdoba",
        "Corrientes",
        "Entre Ríos",
        "Formosa",
        "Jujuy",
        "La Pampa",
        "La Rioja",
        "Mendoza",
        "Misiones",
        "Neuquén",
        "Río Negro",
        "Salta",
        "San Juan",
        "San Luis",
        "Santa Cruz",
        "Santa Fe",
        "Santiago del Estero",
        "Tierra del Fuego",
        "Tucumán",
        "Ciudad Autónoma de Buenos Aires",
      ],

      provincia_selected: null,
      my_role: "",
      my_departament: "",
      assigned: false,
      agents: [],
      agent_selected: null,
      departaments: [],
      departament_selected: null,
      origin_selected: null,
      origins: [
        "landing-ventas",
        "whatsapp",
        "afiliciaciononline",
        "crm-consultas",
        "crm-ventas",
        "programa-referidos",
      ],
      date_from: null,
      date_to: null,
      columns_origin: [
        { title: "Lead", cards: [] },
        { title: "Prospecto", cards: [] },
        { title: "Auditor", cards: [] },
        { title: "Calificado", cards: [] },
        { title: "Cierre", cards: [] },
        { title: "Carga", cards: [] },
        { title: "Digital", cards: [] },
        { title: "Físico", cards: [] },
        { title: "Alta", cards: [] },
      ],
      loading: false,
      searchValue: "",
      columns: [],
      filtersOpen: true,
      isMobileViewport: null,
    };
  },
  methods: {
    syncFiltersForViewport() {
      const isMobile = window.innerWidth <= 768;
      if (this.isMobileViewport !== isMobile) {
        this.isMobileViewport = isMobile;
        this.filtersOpen = !isMobile;
      }
    },
    async generateExcelReport() {
      if (this.my_role == 1) {
        this.loading = true;
        try {
          let response = await this.$repositories.sales.downloadReport(
            moment(this.date_from).format("YYYY-MM-DD"),
            moment(this.date_to)
              .set({ hour: 23, minute: 59, second: 59 })
              .format("YYYY-MM-DD HH:mm:ss")
          );
          console.log(response);
        } catch (error) {
          console.log("Catch error: ", error);
        } finally {
          this.loading = false;
        }
      }
    },
    switchSales() {
      if (
        this.my_role == 1 &&
        (this.my_departament == 1 ||
          this.my_departament == 6 ||
          this.my_departament == 3 ||
          this.my_departament == 28)
      ) {
        this.loading = true;
        try {
          for (let index = 0; index < this.columns_origin.length; index++) {
            this.columns[index].cards = this.columns_origin[index].cards.filter(
              (card) => {
                if (this.assigned) {
                  return card.agent_id != "";
                } else {
                  return card.agent_id == "";
                }
              }
            );
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      } else {
        for (let index = 0; index < this.columns.length; index++) {
          this.columns[index].cards = this.columns_origin[index].cards;
        }
      }
    },
    resetFilters() {
      this.provincia_selected = null;
      this.origin_selected = null;
      this.departament_selected = null;
      this.agent_selected = null;
      this.assigned = false; // si aplica

      this.resetSearch(); // limpia búsqueda y vuelve a fetchSales()
    },

    filterLeads() {
      for (let index = 0; index < this.columns_origin.length; index++) {
        const items = this.columns_origin[index].cards.filter((lead) => {
          let result = true;

          if (this.origin_selected && lead.origin !== this.origin_selected) {
            result = false;
          }

          if (
            this.provincia_selected &&
            lead.province !== this.provincia_selected
          ) {
            result = false;
          }

          if (
            this.departament_selected &&
            lead.agent_departament !== this.departament_selected
          ) {
            result = false;
          }
          if (this.agent_selected && lead.agent_id !== this.agent_selected) {
            result = false;
          }

          return result;
        });
        this.columns[index].cards = items;
      }
    },

    resetSearch() {
      this.searchValue = "";
      this.fetchSales(); // vuelve a ejecutar la consulta al backend
    },

    async searching() {
      try {
        if (!this.searchValue || this.searchValue.trim() === "") {
          console.log("🔍 Sin término de búsqueda, reseteando ventas...");
          await this.fetchSales(); // trae todo de nuevo
          return;
        }

        console.log("🔍 Buscando en backend:", this.searchValue);

        this.loading = true;
        await this.fetchSales(); // fetchSales ya usa this.searchValue
        console.log("📊 Búsqueda finalizada. Columnas:", this.columns);
      } catch (error) {
        console.error("❌ Error en searching:", error);
      } finally {
        this.loading = false;
      }
    },

    normalizeString(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },

    showAgents() {
      this.agent_selected = null;
      this.fetchAgents();
    },
    async fetchDepartaments() {
      this.loading = true;
      try {
        const response = await this.$repositories.departaments.list();
        this.departaments = response.data.departaments
          .filter((departament) => departament.is_marketer)
          .sort((a, b) => a.name.localeCompare(b.name));
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async fetchAgents() {
      this.loading = true;
      try {
        if (this.departament_selected) {
          const response = await this.$repositories.agents.departament(
            this.departament_selected
          );
          this.agents = response.data.users.sort((a, b) =>
            a.lastname.localeCompare(b.lastname)
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async fetchSales() {
      this.loading = true;
      try {
        // reset
        this.columns = [];

        const query = await this.$repositories.sales.index(
          this.searchValue, // 👈 asegurate que sea searchValue
          moment(this.date_from).format("YYYY-MM-DD"),
          moment(this.date_to)
            .set({ hour: 23, minute: 59, second: 59 })
            .format("YYYY-MM-DD HH:mm:ss")
        );

        // agrupar por status
        const grouped = {};

        query.data.sales.forEach((item) => {
          let color = "success";

          const time_created_at = new Date(item.created_at).getTime();
          let diftime_created_at =
            (new Date().getTime() - time_created_at) / 1000 / 60 / 60;

          if (item.user) {
            if (item.updated_at_stage) {
              const diftime =
                (new Date().getTime() -
                  new Date(item.updated_at_stage).getTime()) /
                1000 /
                60 /
                60;
              color =
                diftime > 48 ? "danger" : diftime > 24 ? "warning" : "success";
            } else {
              const diftime =
                (new Date().getTime() - new Date(item.updated_at).getTime()) /
                1000 /
                60 /
                60;
              color =
                diftime > 48 ? "danger" : diftime > 24 ? "warning" : "success";
            }
          } else {
            if (diftime_created_at > 48) {
              color = "danger";
            } else if (diftime_created_at > 24) {
              color = "warning";
            }
          }

          const ITEMS = {
            id: item.id,
            origin: item.inherited_origin ? item.inherited_origin : item.origin,
            ticket_id: item.ticket_id,
            status: item.status,
            contact_fullname: item.contact ? item.contact.fullname : "",
            province: item.contact ? item.contact.province : "",
            phone: item.contact ? item.contact.phone : "",

            agent_id: item.user != null ? item.user.id : "",
            agent_name: item.user != null ? item.user.name : "",
            agent_lastname: item.user != null ? item.user.lastname : "",
            agent_departament:
              item.user != null ? item.user.departaments?.[0]?.id || "" : "",

            agent_avatar: item.user != null ? item.user.avatar : "",
            date: item.created_at,
            color,
          };

          if (!grouped[item.status]) {
            grouped[item.status] = [];
          }
          grouped[item.status].push(ITEMS);
        });

        // ordenar las columnas según el flujo que definiste
        const STATUS_ORDER = [
          "not attended",
          "open",
          "in process",
          "closed",

          "discarded",
        ];

        const STATUS_LABELS = {
          "not attended": "Lead",
          open: "Contactado",
          "in process": "En proceso",
          closed: "Validado",

          discarded: "Rechazado",
        };

        this.columns = STATUS_ORDER.map((status) => ({
          title: STATUS_LABELS[status] || status,
          cards: grouped[status] || [],
        }));

        // guardamos la copia original
        this.columns_origin = JSON.parse(JSON.stringify(this.columns));
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },

  created() {
    const session = this.$store.getters["getSession"];
    const firstDept = session.departaments?.[0]; // primer departamento del usuario

    // Si el usuario pertenece a un departamento marketer
    const isMarketer = firstDept?.is_marketer === true;

    if (isMarketer) {
      this.date_from = moment().subtract(3, "months").toDate();
    } else {
      this.date_from = moment().subtract(1, "months").toDate();
    }

    this.date_to = moment().toDate();
    this.fetchSales();
    this.fetchDepartaments();

    this.my_role = session.role_id;
    this.my_departament = firstDept?.id || null;

    this.$EventBus.$on("SaleUpdate", () => {
      this.fetchSales();
    });
  },
  mounted() {
    this.syncFiltersForViewport();
    window.addEventListener("resize", this.syncFiltersForViewport);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.syncFiltersForViewport);
    this.$EventBus.$off("SaleUpdate");
  },
};
</script>

<style lang="scss" scoped>
#sales-page {
  position: relative;
  height: 100vh;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  > .sales-board-columns {
    height: calc(100vh - 250px);
    overflow-x: auto;
    overflow-y: hidden;
  }

  .sales-filters-panel {
    .filters {
      margin-bottom: .75rem;
    }

    .sales-secondary-filters {
      align-items: center;
      margin-top: 0 !important;
      margin-bottom: .75rem !important;

      > .column {
        padding-top: 0;
        padding-bottom: 0;
      }

      .field {
        margin-bottom: 0;
      }

      .level {
        margin-bottom: 0;
      }
    }
  }
}
.h-fit-content {
  height: fit-content !important;
}
.b-datepicker-content {
  right: 0;
  left: auto;
}

.sales-filters-toggle {
  display: none;
}

@media (max-width: 768px) {
  #sales-page {
    height: auto;
    min-height: 100%;
    padding: 1rem 0;
    overflow-x: hidden;

    > .columns.mx-4 {
      display: flex;
      flex-wrap: wrap;
      margin: 0 .75rem !important;

      > .column {
        width: 100%;
        padding: .35rem;
      }
    }

    .sales-filters-toggle {
      display: flex;
      width: calc(100% - 1.5rem);
      margin: .75rem;
    }

    .sales-filters-panel {
      margin: 0 .75rem .75rem;
      padding: .75rem;
      background: #fff;
      border: 1px solid #e6edef;
      border-radius: 10px;
    }

    .filters {
      display: flex !important;
      flex-wrap: wrap;
      gap: .5rem;
      margin: 0 !important;

      .select,
      .select select {
        width: 100%;
        max-width: 100%;
        margin-right: 0 !important;
      }
    }

    .sales-filters-panel > .columns.mx-4 {
      display: block;
      margin: 0 !important;

      > .column {
        width: 100%;
        padding: .35rem 0;
      }
    }

    .level,
    .level-left,
    .level-right,
    .level-item {
      display: block;
      width: 100%;
    }

    .level-item .field {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: .5rem;
    }

    > .sales-board-columns {
      height: auto;
    }
  }
}
</style>
